import React, { useState } from 'react';
import { Badge } from 'reactstrap';
import _ from 'lodash';

const filterDescription = (key, value, vendorData) => {
  if (key === 'sku') return `SKU is like "${value}"`
  if (key === 'name') return `Item Name is like "${value}"`
  if (key === 'vendor') return `Vendor is "${vendorData.find((v) => v.id == value).name}"`
  if (key === 'disabled') return `Status is "archived"`
  return key
}

const sorterDescription = (sorting) => {
  if (sorting.id === 'LOWER(sku)') {
    if (sorting.direction === 'asc') return `SKU Ascending`
    if (sorting.direction === 'desc') return `SKU Descending`
  }
  if (sorting.id === 'LOWER(name)') {
    if (sorting.direction === 'asc') return `Name Ascending`
    if (sorting.direction === 'desc') return `Name Descending`
  }
  if (sorting.id === 'vendors.name') {
    if (sorting.direction === 'asc') return `Vendor Name Ascending`
    if (sorting.direction === 'desc') return `Vendor Name Descending`
  }
  if (sorting.id === 'cost') {
    if (sorting.direction === 'asc') return `Cost Ascending`
    if (sorting.direction === 'desc') return `Cost Descending`
  }
  if (sorting.id === 'default_price') {
    if (sorting.direction === 'asc') return `Default Price Ascending`
    if (sorting.direction === 'desc') return `Default Price Descending`
  }
  if (sorting.id === 'item_types.name') {
    if (sorting.direction === 'asc') return `Item Type Ascending`
    if (sorting.direction === 'desc') return `Item Type Descending`
  }
};

export default function SearchBar({ filters, setFilters, sorting, onSortingChange, vendorData }) {
  const [field, setField] = useState('');
  const [value, setValue] = useState('');
  const onSubmit = (e) => {
    e.preventDefault()
    if (!!field && !!value) {
      setFilters({ ...filters, [field]: value })
      setField('')
      setValue('')
    }
  }
  const filterKeys = Object.keys(filters || []);
  const sortedVendors = vendorData?.sort((a, b) => a?.name.localeCompare(b?.name)) || [];
  return (
    <>
      <div className="flex-bin-container">
        <div className="flex-bin-one">
          <form className="filter-bin" action="/items" acceptCharset="UTF-8" method="get">
            <input name="utf8" type="hidden" value="✓" autoComplete="off" />
            <div className='form-control' style={{ border: 'none' }}>
              <label>Filter By</label>
              <select
                name="filter-Key"
                id="filter-key"
                defaultValue=""
                className='form-control'
                onChange={(e) => setField(e.target.value)}
              >
                <option disabled value="">Select a Field to Filter By...</option>
                <option value="name">Name</option>
                <option value="sku">SKU</option>
                <option value="vendor">Vendor</option>
                <option value="disabled">Status</option>
                {/* <option value="vendor_name">Vendor Name</option> */}
              </select>
            </div>
            {
              field === 'vendor'
                ? (
                  <div className='form-control' style={{ border: 'none' }}>
                    <label>Vendor</label>
                    <select
                      name="vendor"
                      id="vendor"
                      defaultValue=""
                      className='form-control'
                      onChange={(e) => setValue(e.target.value)}
                    >
                      <option disabled value="">Select a Vendor to Filter By...</option>
                      {
                        sortedVendors.map((v) => (
                          <option
                            key={v.id}
                            disabled={filterKeys.includes('name')}
                            value={v.id}
                          >
                            {v.name}
                          </option>
                        ))
                      }

                    </select>
                  </div>
                )
                : null
            }
            {
              field === 'disabled'
                ? (
                  <div className='form-control' style={{ border: 'none' }}>
                    <label>Status</label>
                    <select
                      name="disabled"
                      id="disabled"
                      defaultValue=""
                      className='form-control'
                      onChange={(e) => setValue(e.target.value)}
                    >
                      <option disabled value="">Select a Status to Filter By...</option>
                        <option
                          key="archived"
                          value={true}
                        >
                          Archived
                        </option>

                    </select>
                  </div>
                )
                : null
            }
            {
              field !== 'vendor' && field !== 'disabled'
                ? (
                  <div className='form-control' style={{ border: 'none' }}>
                    <label>Keyword</label>
                    <input
                      type="text"
                      name="keyword"
                      id="keyword"
                      placeholder="Filter Items"
                      className="form-control"
                      onChange={(e) => setValue(e.target.value)}
                    />
                  </div>
                ) : null
            }
            <input
              style={{ marginTop: 24 }}
              type="submit"
              onClick={onSubmit}
              name="commit"
              value="Filter"
              className="btn btn-secondary btn-upload"
              data-disable-with="Filter" />
          </form>
        </div>
      </div>
      <div className="flex-bin-container">
        <div className="flex-bin-one" style={{ marginBottom: 20 }}>
          {
            Object.keys(sorting || {}).length
              ? (
                <Badge style={{ marginRight: 10 }}>
                  Sort By:
                  {' '}
                  {sorterDescription(sorting)}
                  {' '}
                  <button
                    style={{ backgroundColor: 'transparent', border: 'none', color: 'white' }}
                    onClick={() => onSortingChange(null)}
                  >&#10006;
                  </button>
                </Badge>) 
              : null
          }
          {
            filterKeys.map((key) => (
              <Badge key={key} style={{ marginRight: 5 }}>
                Filter:
                {' '}
                {filterDescription(key, filters[key], vendorData)}
                {' '}
                <button
                  style={{ backgroundColor: 'transparent', border: 'none', color: 'white' }}
                  onClick={() => setFilters(_.omit(filters, key))}
                >&#10006;
                </button>
              </Badge>
            ))
          }
        </div>
      </div>
    </>
  );
}